import { Icons } from 'contents/icons';
import { StyledIconComponent } from './style';
import { ColorValue, ThemeColorType } from 'types/common/CommonType';

/**
 * 아이콘 컴포넌트 속성
 */
interface IconComponentProps {
  /**
   * 사용할 아이콘명 (파일명의 Pascal Case로 입력)
   */
  icon: keyof typeof Icons;
  /**
   * 아이콘의 가로 및 세로 크기 (px단위로 입력)
   */
  size: number;
  /**
   * 아이콘 선의 색상 (색상 변수명)
   */
  stroke: ColorValue;
  /**
   * 아이콘 회전이 필요할 경우, 회전 각도
   */
  rotate?: number;
  /**
   * 아이콘 굵기 값
   */
  strokeWidth?: number;
  /**
   * 아이콘 커스텀 인라인 스타일
   */
  style?: React.CSSProperties;
  /**
   * 아이콘 클래스명
   */
  className?: string;
  /**
   * 아이콘의 배경 색상 (색상 변수명)
   */
  fill?: ColorValue;
  /**
   * Hover시 배경 색상 (색상 변수명)
   */
  hoverBackground?: ColorValue;
  /**
   * Hover시 아이콘 선 색상 (색상 변수명)
   */
  hoverStroke?: ColorValue;
  /**
   * active시 배경 색상 (색상 변수명)
   */
  activeBackground?: ColorValue;
  /**
   * active시 아이콘 선 색상 (색상 변수명)
   */
  activeStroke?: ColorValue;
  /**
   * 아이콘 외곽 border radius 값
   */
  borderRadius?: string;
}

/**
 * Icon component
 * @author hc_yang
 * @param {IconComponentProps} param
 * @returns JSX.Element
 */
export const Icon = (props: IconComponentProps) => {
  const {
    icon,
    size,
    stroke,
    rotate,
    strokeWidth,
    style,
    className,
    fill,
    hoverBackground,
    hoverStroke,
    activeBackground,
    activeStroke,
    borderRadius,
  } = props;
  const IconImg = Icons[icon];
  return (
    <StyledIconComponent
      $size={size}
      $stroke={stroke}
      $fill={fill || 'NULL'}
      $strokeWidth={strokeWidth || 1.8}
      $rotate={rotate || 0}
      $hoverBackground={hoverBackground || 'transparent'}
      $hoverStroke={hoverStroke || stroke}
      $activeBackground={activeBackground || 'transparent'}
      $activeStroke={activeStroke || stroke}
      $borderRadius={borderRadius || '0'}
      className={className}
    >
      <IconImg style={style} />
    </StyledIconComponent>
  );
};
